// project import
import Routes from "routes";
import ThemeCustomization from "themes";
import ScrollTop from "components/ScrollTop";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { AI_getUserData } from "APIs/user";
import socket from "socket/index";
import { AI_getBoards } from "APIs/board";
import NotificationSetup from "notification/NotificationSetup";
import { useInstance } from "../node_modules/easy-redux-http-call/dist/index";
import WhatsNewModal from "components/common-component/WhatsNewModal";

const App = () => {
  const getUserData = useInstance(AI_getUserData);
  const [whatsNewRelease, setWhatsNewRelease] = useState(null);
  const [whatsNewOpen, setWhatsNewOpen]       = useState(false);

  useLayoutEffect(() => {
    if (localStorage.getItem("token")) {
      AI_getUserData.call();
    }
  }, []);

  // Fetch the latest unseen release once user data is ready
  useEffect(() => {
    if (!getUserData?.data?.status) return;

    fetch(`${process.env.REACT_APP_API}/release/latest`, {
      headers: { Authorization: localStorage.getItem("token") },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status && data?.release) {
          setWhatsNewRelease(data.release);
          setWhatsNewOpen(true);
        }
      })
      .catch(() => {});
  }, [getUserData?.data?.status]);

  const handleDismiss = () => {
    if (whatsNewRelease?.id) {
      fetch(`${process.env.REACT_APP_API}/release/${whatsNewRelease.id}/seen`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      }).catch(() => {});
    }
    setWhatsNewOpen(false);
  };

  // Close without marking seen — will reappear next login
  const handleClose = () => setWhatsNewOpen(false);

  const callBoardApi = (id) => {
    AI_getBoards.refetchAction({
      params: {
        project_id: id,
      },
    });
  };

  // useEffect(() => {
  //   socket.connect();
  //   socket.on("connect", () => {
  //     console.log("A new user connected");
  //   });

  //   // TASK
  //   socket.on("drag_and_drop_task", (data) => callBoardApi(data));
  //   socket.on("update_task", (data) => callBoardApi(data));
  //   socket.on("add_task", (data) => callBoardApi(data));
  //   socket.on("assign_member", (data) => callBoardApi(data));
  //   socket.on("assign_lable", (data) => callBoardApi(data));
  //   socket.on("delete_task", (data) => callBoardApi(data));

  //   // BOARD
  //   socket.on("drag_and_drop_board", (data) => callBoardApi(data));
  //   socket.on("add_board", (data) => callBoardApi(data));

  //   socket.on("connect_error", (err) => {
  //     console.log("Connection error", err);
  //   });
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
      </ScrollTop>
      <NotificationSetup />
      <WhatsNewModal
        open={whatsNewOpen}
        release={whatsNewRelease}
        onDismiss={handleDismiss}
        onClose={handleClose}
      />
    </ThemeCustomization>
  );
};

export default App;
